import { create } from 'zustand';

/**
 * Navigation state values correspond 1:1 to camera rigs.
 * Source: 03-RESEARCH.md Pattern 1 (XState Navigation Machine).
 */
export type NavStateValue =
  | 'idle'
  | 'boarding'
  | 'streetcarRiding'
  | 'arrivalCinematic'
  | 'freeWalk'
  | 'guidedTour'
  | 'photoCompare';

/** Axis-aligned bounding box in world space. */
export interface AABB {
  min: [number, number, number];
  max: [number, number, number];
}

interface NavStore {
  navState: NavStateValue;
  cameraPosition: [number, number, number];
  cameraQuaternion: [number, number, number, number];
  /** Wall AABBs the walk controller checks per frame. Populated from manifest.objects with collision=true. */
  collisionBoxes: AABB[];
  /** Single outer AABB defining the walkable bowl (NAV-07). */
  outerBoundary: AABB | null;
  /** True while the vignette feedback overlay should be visible. */
  boundaryHit: boolean;
  setNavState: (s: NavStateValue) => void;
  setCameraPose: (
    p: [number, number, number],
    q: [number, number, number, number]
  ) => void;
  setCollisionBoxes: (boxes: AABB[]) => void;
  setOuterBoundary: (b: AABB | null) => void;
  setBoundaryHit: (hit: boolean) => void;
}

export const useNavStore = create<NavStore>((set) => ({
  navState: 'idle',
  cameraPosition: [0, 1.7, 0],
  cameraQuaternion: [0, 0, 0, 1],
  collisionBoxes: [],
  outerBoundary: null,
  boundaryHit: false,
  setNavState: (navState) => set({ navState }),
  setCameraPose: (p, q) => set({ cameraPosition: p, cameraQuaternion: q }),
  setCollisionBoxes: (collisionBoxes) => set({ collisionBoxes }),
  setOuterBoundary: (outerBoundary) => set({ outerBoundary }),
  setBoundaryHit: (boundaryHit) => set({ boundaryHit }),
}));
